export default class Reviews {
  constructor() {
    this.apiKey = document.body.dataset.reviewsKey;
  }

  async fetchReviews({ productId, key }) {
    try {
      const res = await fetch(
        `https://api.yotpo.com/v1/widget/${this.apiKey}/products/${productId}/reviews.json?sort=time`
      );

      const data = await res.json();
      return data;
    } catch (err) {
      console.log("THERE WAS AN ERROR", err);
    }
  }
}
